import React, { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { parseBase64AuthData, storeAuthData } from '../../utils/authStorage';

/**
 * AuthCallback Component
 * Handles the /auth route to parse base64 credentials from URL,
 * store them in localStorage, and redirect appropriately
 */
const AuthCallback: React.FC = () => {
    const location = useLocation();
    const history = useHistory();

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const keyParam = searchParams.get('key');

        if (!keyParam) {
            // No key parameter provided
            history.replace('/unauthorized');
            return;
        }

        const authData = parseBase64AuthData(keyParam);
        console.log('auth data', authData);

        if (!authData) {
            // Failed to parse base64 data
            history.replace('/unauthorized');
            return;
        }

        // Store auth data to localStorage
        storeAuthData(authData);

        // Redirect to main notification UI
        history.replace('/');
    }, [location, history]);

    // Show loading state while processing
    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            backgroundColor: '#f5f5f5',
        }}
        >
            <div style={{
                textAlign: 'center',
                color: '#666',
            }}
            >
                <div style={{
                    fontSize: '16px',
                    fontWeight: 500,
                }}
                >
                    Authenticating...
                </div>
            </div>
        </div>
    );
};

export default AuthCallback;
